module.exports = __webpack_public_path__ + "static/img/uniuni.bc07923.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/uniuni.gif
// module id = eIPt
// module chunks = 0